import { Component, OnInit, ErrorHandler } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from '../../../shared/user.service';
import swal from 'sweetalert2';
import { Search } from '../../../shared/user.model';

@Component({
  selector: 'app-internal-users-grid',
  templateUrl: './internal-users-grid.component.html',
  styleUrls: ['./internal-users-grid.component.css']
})
export class InternalUsersGridComponent implements OnInit {
  title = "View InternalUser";
 // s: Search;
  itemsPerPage: number = 5;
  currentPage: number = 1;
  totalItems: number;
  internaluserList:any=[];
  ul:any={};
  s: Search;
  isSearch:boolean = false;
  data: any;

  constructor(private userService: UserService,private route: ActivatedRoute,private router: Router, private errorHandler:ErrorHandler) { 
    this.s = new Search();
    this.isSearch = false;
  }

  ngOnInit() {
    this.GetAllInternalUsers(this.itemsPerPage, 1)
  }

  pageChanged(pageNumber: number) {
    //if (this.isSearch)
      //this.onSearch(this.s, this.itemsPerPage, pageNumber);
   // else
      this.GetAllInternalUsers(this.itemsPerPage, pageNumber);
  }

  itemsPerPageChanged(itemsPerPage: number, pageNo: number) {
   // if (this.isSearch)
      //this.onSearch(this.s, this.itemsPerPage, pageNo);
    //else
      this.GetAllInternalUsers(this.itemsPerPage, pageNo);
  }

  GetAllInternalUsers(itemsPerPage: number, pageNo: number) {
    debugger;
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.getAllInternalUsers(itemsPerPage, pageNo)
      .subscribe(
        (data: any) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.internaluserList = data.internalUsermodel;
          this.totalItems = data.TotalItemsCount;
          this.itemsPerPage = itemsPerPage;
          this.currentPage = pageNo;

          console.log(this.internaluserList);
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
   //this.errorHandler.HandlerError(error);
        });
  }

  //wrkng
  // DeleteInternalUser(Tr_Id){
  //   debugger;
  //   swal({
  //        title: 'Are you sure?', text: "You want to delete!", type: 'warning', showCancelButton: true, confirmButtonColor: '#3085d6', cancelButtonColor: '#d33', confirmButtonText: 'Yes, delete it!'
  //     }).then((result) => {
  //       if (result.value) {
  //       this.data = this.userService.DeleteInternalUser(Tr_Id);
  //       this.data.subscribe(
  //        (response: any) => {
  //            this.
  //            GetAllInternalUsers(this.itemsPerPage, 1)          
  //        },       
  //     ); 
  //   } 
  //   })
  //   }





    ActivateInactivateUsers(id: string, inActive: string) {
      debugger;
      if (inActive == 'N') {
        swal({
          title: 'Are you sure?', text: "You want to inactivate!", type: 'warning', showCancelButton: true, confirmButtonColor: '#3085d6', cancelButtonColor: '#d33', confirmButtonText: 'Yes, inactivate it!'
        }).then((result) => {
          if (result.value) {
            this.ActivateInactivateUser(id, inActive);
          }
        })
      }
      else {
        swal({
          title: 'Are you sure?', text: "You want to activate!", type: 'warning', showCancelButton: true, confirmButtonColor: '#3085d6', cancelButtonColor: '#d33', confirmButtonText: 'Yes, activate it!'
        }).then((result) => {
          if (result.value) {
            this.ActivateInactivateUser(id,'N');
          }
        })
      }
    }
  
    ActivateInactivateUser(id: string,inActive:string) {
        document.getElementById('loader-spinner').style.display = "block";
        this.userService.DeleteInternalUser(id,inActive)
          .subscribe(
            (data) => {
              this.GetAllInternalUsers(this.itemsPerPage,1);
              document.getElementById('loader-spinner').style.display = "block";
              if(inActive=='N')
            swal('Inactivated!', 'User has been inactivated.', 'success');
            else
            swal('Activated!', 'User has been activated.', 'success');
            }, (error) => {
              document.getElementById('loader-spinner').style.display = "none";
              this.errorHandler.handleError(error);
              //swal({ text: 'Please delete all users belonging to this Role.' });
            });
          
    }

    onSearch(s, itemsPerPage: number, pageNo: number) {   
      this.isSearch = true;
      let searchText = this.s.SearchText;
      let searchCriteria = this.s.SearchCriteria;
      if (searchText == "" || searchText == null || searchCriteria == "" || searchCriteria == null)
        swal("Warning!", "Please enter the search criteria and search text.", "warning");
      else {
        document.getElementById('loader-spinner').style.display = "block";
        this.userService.SearchInternalUser(searchCriteria, searchText,itemsPerPage,pageNo)
          .subscribe(
            (data: any) => {
              if(data.internalUsermodel.length!=0){              
            this.internaluserList = data.internalUsermodel;
            this.totalItems = data.TotalItemsCount;
            this.itemsPerPage = itemsPerPage;
            this.currentPage = pageNo;
              document.getElementById('loader-spinner').style.display = "none";
            }
            else
            {
            document.getElementById('loader-spinner').style.display = "none";         
            }
            }, (error) => {
              document.getElementById('loader-spinner').style.display = "none";
              //swal('Search Failed.');
              //this.errorHandler.HandlerError(error);
            });
      }
    }
  
  
 

}



// WEBPACK FOOTER //
// ./src/app/masters/internal-users/internal-users-grid/internal-users-grid.component.ts